module.exports = __webpack_public_path__ + "static/media/catarina_coutinho.172f4200.jpg";